export enum NavigateFrom {
  LEARNING_PATH = 'learning-path',
  ITSELF = 'itself',
  CHALLENGE = 'challenge',
  CLASS = 'class',
  COURSE = 'course',
  MODULE = 'module'
}
